/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Icon, Illustration, Button } from 'fpay-ui';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';

const ChildrenContainer = styled.div`
  margin-top: -19px;
`;
const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ButtonDownload = styled(Button)`
  width: 164px;
  margin-right: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`;

const ButtonFpay = styled(Button)(
  ({ theme }) => css`
    width: 164px;
    ${theme.textTypes['Subtitle-1-w400']}
    text-align: center;
  `
);

const Span = styled.span(
  ({ theme }) => css`
    margin-left: 5px;
    ${theme.textTypes['Subtitle-1-w400']}
    text-align: center;
    color: ${theme.colors.gbrand500};
  `
);

const h2Style = {
  fontFamily: 'Roboto',
  fontSize: '24px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  marginTop: '0',
  marginBottom: '10px',
  lineHeight: '1.33',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#444b62',
};

const h3Style = {
  fontFamily: 'Roboto',
  fontSize: '18px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  marginTop: '0',
  marginBottom: '10px',
  lineHeight: '1.33',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#444b62',
};

export const Image = styled(Illustration)`
  width: 150px; // debe ser 114px y da 82
  height: 150px; // debe ser 114px y da 82
  margin-top: 62px;
`;

const SuccessRefund = ({ handleClick, handleDownload, children }) => {
  const { t } = useTranslation();

  const gridProds = { justify: 'center', container: true };
  return (
    <Grid item xs={12}>
      <Grid item xs={12} {...gridProds}>
        <Image name="success" />
      </Grid>
      <Grid item xs={12} {...gridProds}>
        <h2 data-testid="success-refund-title" style={{ ...h2Style, marginTop: '25px' }}>
          {t('paymentsFoundsOut.success.title')}
        </h2>
      </Grid>
      <Grid item xs={12} {...gridProds}>
        <h2 data-testid="success-refund-subtitle" style={{ ...h2Style, marginBottom: '0' }}>
          {t('paymentsFoundsOut.success.subtitle')}
        </h2>
      </Grid>
      <Grid item xs={12} {...gridProds}>
        <h3 data-testid="success-refund-subtitle" style={{ ...h3Style, marginBottom: '35px' }}>
          {t('paymentsFoundsOut.success.noValid')}
        </h3>
      </Grid>

      {children && (
        <Grid item xs={12} {...gridProds}>
          <Grid item xs={12} sm={8} md={4}>
            <ChildrenContainer>{children}</ChildrenContainer>
          </Grid>
        </Grid>
      )}

      <Grid item xs={12} {...gridProds} style={{ paddingTop: '0px' }}>
        <Grid item xs={12} sm={8} md={4}>
          <ButtonContainer>
            {handleDownload && (
              <ButtonDownload onClick={handleDownload} type="outlined" testId="button-download">
                <Icon icon="ic-downloadAll" /** width="20" height="20" */ />
                <Span>{t('paymentsFoundsOut.download.button')}</Span>
              </ButtonDownload>
            )}

            <ButtonFpay onClick={handleClick} testId="button-success">
              {t('transactions.refunds.successButton')}
            </ButtonFpay>
          </ButtonContainer>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SuccessRefund;

SuccessRefund.propsTypes = {
  handleClick: PropTypes.func,
  handleDownload: PropTypes.func,
  children: PropTypes.any,
};

SuccessRefund.defaultProps = {
  handleClick: () => {},
  handleDownload: () => {},
};
